<button  id="refresh-button" aria-label="Refresh grid"  mat-icon-button (click)="handleAdxClick()">
    <mat-icon fontIcon="replay"></mat-icon>
</button>